module.exports = "<ui-view></ui-view>"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/pop-up/pop-up.html
// module id = 821
// module chunks = 0